<template>
  <div class="flex center-xs">
    <div class="input-container">
      <div class="row vertical-center">
        <div class="col xs-1">
          <input
            type="checkbox"
            v-bind:GDPRChecked="GDPRChecked"
            v-on:change="$emit('change', $event.target.checked)"
          >
        </div>
        <div class="col xs-11">
          <p class="small-text text-left space-top-0">
            {{ agreement }}
          </p>
          </div>
      </div>
      <p v-html="notice" class="small-text text-left"></p>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'GDPRChecked',
    event: 'change'
  },
  props: {
    GDPRChecked: Boolean,
    agreement: String,
    notice: String
  }
}
</script>

<style>

</style>